import type { FC } from 'react';
import { useTranslation } from '@presentation/utils';
import * as Styled from '../styled';
import type { PrebookingWarningProps } from '../types';

export const PrebookingWarning: FC<PrebookingWarningProps> = (props) => {
  const { proWarning, workerServiceWarning } = props;
  const { translate } = useTranslation();
  return (
    <>
      {proWarning && (
        <>
          <Styled.Label>{translate('common.modals.preBooking.title')}</Styled.Label>
          <Styled.PreBookingWarning dangerouslySetInnerHTML={{ __html: proWarning }} />
        </>
      )}
      {workerServiceWarning && (
        <>
          <Styled.Label>{translate('common.modals.preBooking.workerTitle')}</Styled.Label>
          <Styled.PreBookingWarning
            dangerouslySetInnerHTML={{
              __html: workerServiceWarning,
            }}
          />
        </>
      )}
    </>
  );
};
